import type { TranslationKey } from "../../../../../../modules/localization/translations"
import type { ResourceFilterElementValue } from "../../../createOrderTypes"

const RESOURCE_TYPE_ID_TO_TRANSLATION_KEY: Record<number, TranslationKey> = {
    1: "resource-booking-chip-filter-rooms",
    2: "resource-booking-chip-filter-equipment",
    4: "resource-booking-chip-filter-cars",
}

export function getResourceFilterValueDisplayLabel(
    identifier: string,
    value: ResourceFilterElementValue,
    l10n: { getString: (id: TranslationKey) => string },
): string {
    if (identifier === "resourceTypeIds") {
        const numValue = typeof value.value === "number" ? value.value : Number(value.value)
        const key = RESOURCE_TYPE_ID_TO_TRANSLATION_KEY[numValue]
        if (key) return l10n.getString(key)
    }
    return String(value.key)
}
